<script lang="ts" setup generic="T extends object">
import { watchDebounced } from '@vueuse/core';
import { ref } from 'vue';

import { GrammarTextField } from '@nora-monorepo/grammar-ui';
import type { TypesenseSearchResponseDTO } from '@nora-monorepo/nora-api-client';

export interface TypesenseSearchProps {
  placeholder?: string;
  searchCallback: (
    query: string,
  ) => Promise<TypesenseSearchResponseDTO | undefined>;
}

export interface TypesenseSearchEmits {
  (event: 'clear'): void;
  (event: 'results', results: TypesenseSearchResponseDTO): void;
}

const props = defineProps<TypesenseSearchProps>();
const emit = defineEmits<TypesenseSearchEmits>();

const searchQuery = ref<string>('');

watchDebounced(
  searchQuery,
  () => {
    if (!searchQuery.value) {
      emit('clear');

      return;
    }

    handleSearch();
  },
  { debounce: 300, maxWait: 1000 },
);

async function handleSearch() {
  const results = await props.searchCallback(searchQuery.value);

  if (!results) {
    return;
  }

  emit('results', results);
}
</script>

<template>
  <GrammarTextField
    v-model:value="searchQuery"
    :label="placeholder ?? 'Search...'"
    :placeholder="placeholder ?? 'Search...'"
  />
</template>
